import Vue from 'vue';
import Vuex from 'vuex';

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import roles from "./modules/roles-module";
import categories from "./modules/categories-module";
import tags from "./modules/tags-module";
import items from "./modules/items-module";
import customers from "./modules/customers-module";
import registerCustomer from "./modules/register-customer-module";
import locations from "./modules/locations-module";
import devices from "./modules/devices-module";
import cashRegisters from "./modules/cash-registers-module";
import fiscalizeDevice from "./modules/fiscalize-device-module";
import programmingHeader from "./programming/header";
import people from "./modules/people-module";
import userEmail from "./modules/user-email-module";
import licenceFreeing from "./modules/licence-freeing";
import deviceLicenceStatus from "./modules/device-licence-status-module";
import licences from "./modules/licences-module";
import taxOffices from "./modules/tax-offices-module";
import blikRegistrations from "./modules/blik-registrations-module";
import accountActivation from "./modules/account-activation-module";
import deviceComponents from "./modules/device-components-module";
import deviceFirmwareVersions from "./modules/device-firmware-versions-module";
import deviceModelFirmwareVersions from "./modules/device-model-firmware-versions-module";
import services from "./modules/services-module";
import cashRegisterServices from "./modules/cash-register-services-module";
import deviceModels from "./modules/device-models-module";
import personalTokens from "./modules/personal-tokens-module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        alerts,
        profile,
        users,
        roles,
        categories,
        tags,
        items,
        customers,
        registerCustomer,
        locations,
        devices,
        cashRegisters,
        fiscalizeDevice,
        programmingHeader,
        people,
        userEmail,
        licenceFreeing,
        deviceLicenceStatus,
        licences,
        taxOffices,
        blikRegistrations,
        accountActivation,
        deviceComponents,
        deviceFirmwareVersions,
        deviceModelFirmwareVersions,
        services,
        cashRegisterServices,
        deviceModels,
        personalTokens
    }
});